export const clickOutsideIgnoreClass = "ignore-outside-click";
